import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface OwnershipChange {
  id: string;
  policy_id: string;
  previous_owner: string | null;
  new_owner: string;
  changed_by: string;
  changed_at: string;
  previous_owner_profile: { full_name: string } | null;
  new_owner_profile: { full_name: string } | null;
  changed_by_profile: { full_name: string } | null;
}

export function useOwnershipHistory(policyId: string | undefined) {
  return useQuery({
    queryKey: ['ownership-history', policyId],
    queryFn: async () => {
      if (!policyId) return [];

      const { data, error } = await supabase
        .from('policy_ownership_history')
        .select(`
          *,
          previous_owner_profile:profiles!policy_ownership_history_previous_owner_fkey(full_name),
          new_owner_profile:profiles!policy_ownership_history_new_owner_fkey(full_name),
          changed_by_profile:profiles!policy_ownership_history_changed_by_fkey(full_name)
        `)
        .eq('policy_id', policyId)
        .order('changed_at', { ascending: false });

      if (error) throw error;
      return (data ?? []) as OwnershipChange[];
    },
    enabled: !!policyId,
  });
}
